import { CreateCustomerInput, Customer } from "../../api/schema";
import { FlexBox } from "../../components/flex/Flex";
import {
  InputFormMode,
  Mutation,
  ValuesVariables,
} from "../../components/form/InputForm";
import { InputModalBuilder } from "../../components/form/InputModalBuilder";
import { UserLanguage } from "../../lang/lang";
import { CreateCustomerResponse } from "./graphql";
import { CreateCustomerModalKeys } from "./types";

export interface CreateCustomerModalProps {
  bundle: {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    mutation: Mutation<
      CreateCustomerResponse,
      ValuesVariables<CreateCustomerInput>
    >;
  };
}

export const CreateCustomerModal = (props: CreateCustomerModalProps) => {
  return (
    <InputModalBuilder<Customer, CreateCustomerResponse, CreateCustomerInput>
      {...props.bundle}
      keys={CreateCustomerModalKeys()}
      texts={UserLanguage().pages.customer.actions}
      reformId={["payment_condition", "invoice_address"]}
      open={props.bundle.open}
      mode={InputFormMode.Create}
      resetOnClose
    >
      {(builder) => (
        <FlexBox style={{ flexDirection: "column" }}>
          {builder.buildCards()}
          {builder.buildField("name")}
        </FlexBox>
      )}
    </InputModalBuilder>
  );
};
